import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PlanificationTypeList from './PlanificationTypeList';
import PlanificationTypeForm from './PlanificationTypeForm';
import DeletedPlanificationTypesList from './DeletedPlanificationTypesList';
import PlanificationList from './PlanificationList';
import PlanificationForm from './PlanificationForm';
import DeletedPlanificationsList from './DeletedPlanificationsList';

const Planifications = () => {
  return (
    <Routes>
      {/* Planifications */}
      <Route path="/" element={<PlanificationList />} />
      <Route path="/new" element={<PlanificationForm />} />
      <Route path="/:id/edit" element={<PlanificationForm />} />
      <Route path="/deleted" element={<DeletedPlanificationsList />} />

      {/* Planification Types */}
      <Route path="/types" element={<PlanificationTypeList />} />
      <Route path="/types/new" element={<PlanificationTypeForm />} />
      <Route path="/types/:id/edit" element={<PlanificationTypeForm />} />
      <Route path="/types/deleted" element={<DeletedPlanificationTypesList />} />

      <Route path="*" element={<Navigate to="/planifications" replace />} />
    </Routes>
  );
};

export default Planifications;
